import parse from "html-react-parser";
import React from "react";
import Slider from "react-slick";
import RectangleSlider from "../components/public/slider";

export default function SimpleSlider() {
  let settings = {
    // dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 20000,
    autoplaySpeed: 1,
    cssEase: "linear",
  };

  const link =
    '<b><a href="www.google.com">स्मरणिका जाहिरात दर पत्रकासाठी येथे क्लिक करा</a></b>';

  return (
    <div className="div-main">
      <div
        className="Table"
        style={{
          width: "100%",
          height: "100%",
          margin: "0px auto",
          top: "0px",
          background: "transperant",
        }}
      >
        <div className="Row">
          <RectangleSlider />
        </div>
      </div>
    </div>
  );
}
